import AuthService from '../services/auth.service';
import { getSavedState, saveState, removeState } from '../utils/localstorage';

export const auth = {
  namespaced: true,
  state: {
    isLoggedIn: !!getSavedState('auth.token'),
    currentUser: {},
  },
  actions: {
    async tryToLogin({ commit }, login) {
      try{
        const {email, senha} = login;
        const payload = {
          email: email.trim(),
          senha: senha
        }
        const resp = await AuthService.login(payload);
        commit('SET_CURRENT_USER', resp.data.usuario);
        saveState('auth.token', resp.data.token);
        if(resp.data?.usuario?.perfil?.id !== 1){
          document.addEventListener('contextmenu', event => event.preventDefault());
          document.addEventListener('copy', event => event.preventDefault());
          document.addEventListener('cut', event => event.preventDefault());
        }
        return resp
      }catch(error){
        if(error.response){
          //console.error(error.response)
          return error.response
        }else if (error.request) {
          //console.error(error.request);
          return error.request
        } else {
            //console.error('Error', error.message);
            return error
        }
      }
    },

    logout({ commit }) {
      commit('REMOVE_USER');
    },

    async getCurrentUser({commit}, idUser){
      const resp = await AuthService.getCurrentUser(idUser);
      console.log(resp.data)
      commit('SET_CURRENT_USER', resp.data);
    }
  },
  mutations: {
    SET_CURRENT_USER(state, user) {
    
      state.currentUser = user;
      saveState('auth.currentUser', user);
    },
    REMOVE_USER(state, user) {
      state.currentUser = {};
      removeState('auth.currentUser', user);
      removeState('auth.token', user);
    },
  },
};